import React from 'react';
import { Breadcrumbs as MuiBreadcrumbs, Link, Typography } from '@mui/material';
import { useLocation, Link as RouterLink } from 'react-router-dom';
import { useTheme } from "@mui/material/styles";
 
const breadcrumbNameMap = {
  '/dashboard': 'Dashboard',
  '/clusters': 'Clusters',
  '/organization': 'Organization',
  '/Add_Organization': 'Add Organization',
  '/application_template': 'Application Template',
  '/application_template/add_template': 'Add Template',
  '/add_new_tenant': 'Add New Provider',
  '/provider': 'Provider',
  '/settings': 'Settings',
  '/provision-status': 'Provision Status',
  '/metrics': 'Metrics',
  '/application_template/application_form': 'Application Form',
  '/Resources/Services': 'Resources',
  '/diskselect': 'Disk Select',
  '/Resources/Create_Request': 'Create Request',
  '/Resources/View_Resources': 'View Resources',
  '/test': 'Test',
  '/faq': 'FAQs',
  '/application_template/operating_system': 'Operating System',
  '/createuser': 'Create User',
  '/Resources/New_Resources': 'New Resource',
  '/Resources/Operational_Resources': 'Operational Resource',
  '/Resources':'Resources',
  '/bulkEC2Provisioning':'Bulk EC2 Provisioning',
  '/changereqsetup':'Change Request Setup',
  '/awsMasterData': 'Topology Map',
 
};
 
const formatBreadcrumb = (segment) => {
  const words = segment.replaceAll(/[-_]/g, ' ').split(' ');
  return words.map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
};
 
const Breadcrumbs = () => {
  const theme = useTheme();
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);
 
  return (
    <MuiBreadcrumbs aria-label="breadcrumb" sx={{ my: 1, mx: 2 }}>
      {/* <Link
        variant='breadcrumbs'
        component={RouterLink}
        underline="hover"
        color="inherit"
        to="/Resources"
      >
        Home
      </Link> */}
      {pathnames.map((value, index) => {
        const last = index === pathnames.length - 1;
        const to = `/${pathnames.slice(0, index + 1).join('/')}`;
        const breadcrumbName = breadcrumbNameMap[to] || formatBreadcrumb(value);
 
        return last ? (
          <Typography variant='breadcrumbs' color="textPrimary" key={to}>
            {breadcrumbName}
          </Typography>
        ) : (
          <Link
            variant='breadcrumbs'
            component={RouterLink}
            underline="none"
            color="inherit"
            to={to}
            key={to}
            sx={{
  zIndex: "99", position: "relative",
}}
          >
            {breadcrumbName}
          </Link>
        );
      })}
    </MuiBreadcrumbs>
  );
};
 
export default Breadcrumbs;
 